module.exports = __webpack_public_path__ + "img/api-community.0d579983.svg";